export default __webpack_public_path__ + "static/media/twitter (2).8ca892c3.png";